import React from 'react';
import { UncontrolledCollapse, Button, CardBody, Card } from 'reactstrap';

const Cinemax = () => (
  <div>
    <h2>Cinemax</h2>
    <p>7 Channels of Premium Cinemax Content in HD. $16</p>
    <Button outline color="success" id="maxtoggle" style={{ marginBottom: '1rem' }}>
      Show/Hide Channel Listing
    </Button>
    <UncontrolledCollapse toggler="#maxtoggle">
      <Card>
        <CardBody>
          406 - Cinemax<br />
          410 - More Max<br />
          411 - Action Max<br />
          412 - Thriller Max<br />
          413 - 5Star Max<br />
          414 - MovieMax<br />
          415 - OuterMax<br />
        </CardBody>
      </Card>
    </UncontrolledCollapse>
  </div>
);

export default Cinemax;


// WEBPACK FOOTER //
// ./src/components/sections/services/tv/cinemax.js